var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "129.438%",
    x2: "-16.171%",
    y1: "6.055%",
    y2: "67.974%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFDA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#AE7714"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 14,
    height: 14,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "url(#b)",
    fillRule: "nonzero",
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.34471784,13.125 C3.12041767,13.125 2.89761749,13.0562815 2.70718401,12.9209309 C2.37015041,12.6814594 2.20451695,12.2832639 2.27495034,11.8817107 L2.83898411,8.66556886 C2.8623508,8.53236977 2.81721743,8.39653017 2.71825069,8.30222157 L0.328915482,6.02453672 C0.0306152484,5.74014396 -0.0747515008,5.32281289 0.0539819334,4.93534242 C0.182715368,4.54787194 0.518782297,4.27078133 0.931049287,4.21220111 L4.23301854,3.74297261 C4.36978531,3.72354367 4.48791874,3.63960151 4.54908545,3.51839882 L6.02575328,0.592256738 C6.21012009,0.226920913 6.58342038,0 6.99998737,0 C7.4165877,0 7.78988799,0.226920913 7.9742548,0.592256738 L7.97428814,0.592256738 L9.45095596,3.51839882 C9.51208934,3.63960151 9.6302561,3.72354367 9.76698954,3.74297261 L13.0689588,4.21220111 C13.4812258,4.27078133 13.8172594,4.54787194 13.9460261,4.93534242 C14.0747262,5.32281289 13.9694262,5.74014396 13.6711259,6.02453672 L11.2817907,8.30225417 C11.182824,8.39659537 11.1376906,8.53243497 11.1610573,8.66560146 L11.7251244,11.8817433 C11.7955245,12.2832965 11.6299243,12.6815246 11.2928574,12.9209961 C10.9558238,13.160435 10.5173901,13.1913388 10.1487232,13.0018088 L7.19535419,11.4833522 C7.07302076,11.4204363 6.92702065,11.4204689 6.80465389,11.4833522 L3.85131824,13.0018088 C3.69095145,13.0842514 3.51738465,13.125 3.34471784,13.125 Z M7.00002071,0.651945316 C6.83662058,0.651945316 6.69588714,0.737484818 6.62358708,0.880789564 L5.14691926,3.80693164 C4.98861913,4.12059822 4.68281889,4.33786986 4.32888528,4.38816995 L1.02691603,4.85739846 C0.865215902,4.88038068 0.738549136,4.98482754 0.688049097,5.13680359 C0.637549057,5.28877965 0.677249088,5.44610192 0.794282513,5.55765534 L3.18361772,7.83534018 C3.43971792,8.07947331 3.55651801,8.4310524 3.49608463,8.77581833 L2.93205085,11.9919602 C2.9044175,12.149478 2.96685088,12.299596 3.09905099,12.3934808 C3.23125109,12.4873982 3.39648455,12.4991012 3.541118,12.4247105 L6.49448698,10.906254 C6.81105389,10.7435203 7.18902086,10.7435203 7.5056211,10.906254 L10.4589901,12.4247105 C10.6036569,12.4991338 10.7689237,12.4873982 10.9010571,12.3935134 C11.0332905,12.2995634 11.0957239,12.149478 11.0680906,11.9919602 L10.5040235,8.77581833 C10.4435901,8.4310524 10.5603902,8.07950591 10.8165237,7.83534018 L13.2058256,5.55765534 C13.322859,5.44610192 13.3625257,5.28877965 13.312059,5.13680359 C13.2615589,4.98482754 13.1349255,4.88038068 12.9731921,4.85739846 L9.67125613,4.38816995 C9.31732252,4.33786986 9.01148895,4.12059822 8.85322216,3.80693164 L7.376521,0.880789564 L7.37655434,0.880789564 C7.30415428,0.737484818 7.16342084,0.651945316 7.00002071,0.651945316 Z",
    transform: "translate(0 .438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOff);
export default __webpack_public_path__ + "static/media/star_off.2a135d303ed1f6a2f00abd2714eee174.svg";
export { ForwardRef as ReactComponent };